// extracted by mini-css-extract-plugin
export var modal = "_kd-0";